const jsonSchema = [
  {
    name: 'achievement',
    label: 'Achievement',
    type: 'multiselect',
    showInList: true
  },
  {
    type: 'group',
    fields: [
      {
        name: 'date',
        label: 'Date',
        type: 'date',
        required: true,
        showInList: true
      },
      {
        name: 'progress',
        label: 'Progress',
        type: 'number',
        required: false,
        showInList: true
      }
    ]
  }
  // Add more fields as needed
];
export default jsonSchema;
